import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CompanyTagModel } from 'src/models';

const companyTagAdapter: AdapterFunc<GQL.CompanyTagsModel, CompanyTagModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
  description: input.description!,
});

export default companyTagAdapter;
